module.exports = __webpack_public_path__ + "img/list-title-252.f30fe03d.png";